import { useLingui } from "@lingui/react/macro"

import { KVTable } from "#/components/KVTable"

import type { Entry } from "../har"

function ms(name: string, value: number) {
  if (value === -1 || value == null) return

  return { name, value: value.toFixed(2) + " ms" }
}

export function TimelineTab({ entry }: { entry?: Entry }) {
  const { t } = useLingui()

  if (!entry) {
    return null
  }

  return (
    <div css="mx-4 my-3">
      <KVTable
        aria-label={t`Timings`}
        title={t`Timings`}
        values={[
          {
            name: t`Start`,
            value: entry.startedDateTime,
          },
          ms(t`Blocked`, entry.timings.blocked),
          ms(t`DNS`, entry.timings.dns),
          ms(t`Connect`, entry.timings.connect),
          ms(t`Send`, entry.timings.send),
          ms(t`Wait`, entry.timings.wait),
          ms(t`Receive`, entry.timings.receive),
          ms(t`SSL`, entry.timings.ssl),
          ms(t`Total`, entry.time),
        ].filter(Boolean)}
      />
    </div>
  )
}
